// Configuração da aplicação
export const APP_CONFIG = {
  NAME: 'Ergofy',
  SUBTITLE: 'Análise de Riscos Psicossociais'
};

// Enums para manter consistência com o backend
export const IssuedVia = {
  BATCH: 'batch',
  EMAIL: 'email', 
  SMS: 'sms',
  MANUAL: 'manual'
};

// Status de campanhas
export const RunStatus = {
  SCHEDULED: 'scheduled',
  OPEN: 'open',
  CLOSED: 'closed',
  COMPLETED: 'completed', // Concluída automaticamente (todos setores completos)
  ARCHIVED: 'archived'
};

// Roles de usuários
export const UserRole = {
  OWNER: 'owner',
  ADMIN: 'admin',
  MANAGER: 'manager',
  ANALYST: 'analyst',
  VIEWER: 'viewer'
};

// Configurações de paginação
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100]
};

// Configurações de tempo
export const TIME_CONFIG = {
  STALE_TIME: 300000, // 5 minutos
  CACHE_TIME: 600000, // 10 minutos
  RETRY_COUNT: 2
};